/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ProductPipelineStatus {
    NotYetStarted = 'NotYetStarted',
    WaitingForOffertUpload = 'WaitingForOffertUpload',
    CheckOffert = 'CheckOffert',
    WaitingForZusaetzlicheKundendaten = 'WaitingForZusaetzlicheKundendaten',
    WaitingForKundenAntragUnterschrift = 'WaitingForKundenAntragUnterschrift',
    StartPolizzierung = 'StartPolizzierung',
    WaitingForPolizzeUpload = 'WaitingForPolizzeUpload',
    FinishContract = 'FinishContract',
    Completed = 'Completed'
  }

    export const ProductPipelineStatusTranslocoMap: Record<ProductPipelineStatus, string> = {
    [ProductPipelineStatus.NotYetStarted]: 'productPipelineStatus.notYetStarted',
    [ProductPipelineStatus.WaitingForOffertUpload]: 'productPipelineStatus.waitingForOffertUpload',
    [ProductPipelineStatus.CheckOffert]: 'productPipelineStatus.checkOffert',
    [ProductPipelineStatus.WaitingForZusaetzlicheKundendaten]: 'productPipelineStatus.waitingForZusaetzlicheKundendaten',
    [ProductPipelineStatus.WaitingForKundenAntragUnterschrift]: 'productPipelineStatus.waitingForKundenAntragUnterschrift',
    [ProductPipelineStatus.StartPolizzierung]: 'productPipelineStatus.startPolizzierung',
    [ProductPipelineStatus.WaitingForPolizzeUpload]: 'productPipelineStatus.waitingForPolizzeUpload',
    [ProductPipelineStatus.FinishContract]: 'productPipelineStatus.finishContract',
    [ProductPipelineStatus.Completed]: 'productPipelineStatus.completed',
    };

    export const ProductPipelineStatusOptions = [
  { value: ProductPipelineStatus.NotYetStarted, labelKey: 'productPipelineStatus.notYetStarted' },
  { value: ProductPipelineStatus.WaitingForOffertUpload, labelKey: 'productPipelineStatus.waitingForOffertUpload' },
  { value: ProductPipelineStatus.CheckOffert, labelKey: 'productPipelineStatus.checkOffert' },
  { value: ProductPipelineStatus.WaitingForZusaetzlicheKundendaten, labelKey: 'productPipelineStatus.waitingForZusaetzlicheKundendaten' },
  { value: ProductPipelineStatus.WaitingForKundenAntragUnterschrift, labelKey: 'productPipelineStatus.waitingForKundenAntragUnterschrift' },
  { value: ProductPipelineStatus.StartPolizzierung, labelKey: 'productPipelineStatus.startPolizzierung' },
  { value: ProductPipelineStatus.WaitingForPolizzeUpload, labelKey: 'productPipelineStatus.waitingForPolizzeUpload' },
  { value: ProductPipelineStatus.FinishContract, labelKey: 'productPipelineStatus.finishContract' },
  { value: ProductPipelineStatus.Completed, labelKey: 'productPipelineStatus.completed' },
    ];

